const layoutTypes = {
  SET_SIDE_MENU_COLLAPSE: 'SET_SIDE_MENU_COLLAPSE',
  SET_SECOND_MENU_COLLAPSE: 'SET_SECOND_MENU_COLLAPSE',
  SET_SECOND_MENU_KEY: 'SET_SECOND_MENU_KEY',
};

export default layoutTypes;
